import { Company } from '@/api';
import { createContext } from 'react';

export interface CompanyContextData {
    company: Company;
}
export const CompanyContext = createContext<CompanyContextData | undefined>(
    undefined
);
